module.exports = __webpack_public_path__ + "img/selected6-min.4da51967.png";